import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SettingsService } from '../../../core/settings.service';

@Component({
    selector: 'app-checkout-footer',
    template: `
        <footer class="full-page-takeover__footer" *ngIf="settingsService.get() | async as ss">
            <div class="full-page-takeover__footer-content">
                <app-checkout-footer-usp
                    *ngIf="ss.checkout?.footer?.uspItems"
                    [items]="ss.checkout.footer.uspItems">
                </app-checkout-footer-usp>
            </div>
            <p
                *ngIf="ss.checkout?.footer?.description"
                class="full-page-takeover__footer-content full-page-takeover__footer-description text-secondary text-small"
            >
                {{ ss.checkout?.footer?.description }}
            </p>

            <div class="full-page-takeover__footer-content">
                <app-payment-icon-list [list]="ss.checkout?.footer?.paymentIcons"></app-payment-icon-list>
            </div>
        </footer>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutFooterComponent {
    constructor(public settingsService: SettingsService) {}
}
